import Loading from 'components/Loading/Loading';
import React from 'react';
import SettingsRow from '../../../Settings/components/SettingsRow';
import { CardAlarms } from './CardAlarms/CardAlarms';
import { useSelector } from 'react-redux';
import { selectIsLoadingNotificationSettings } from 'store/notifications/selectors/notification-settings.selectors';
import { useTranslation } from 'react-i18next';

export const AlarmSettings = () => {
  const isLoadingNotificationSettings = useSelector(
    selectIsLoadingNotificationSettings
  );

  const { t } = useTranslation('common');

  return (
    <>
      <SettingsRow primary={t('project.employee_card_alarms')}>
        {!isLoadingNotificationSettings ? (
          <CardAlarms></CardAlarms>
        ) : (
          <Loading tiny></Loading>
        )}
      </SettingsRow>
    </>
  );
};
